import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireGameEnabled } from '@/lib/route-guards';

/**
 * Layout route existing only to keep every lobby page unreachable on a client that didn't
 * deploy a lobby. Sitting at the folder root means pages added under it inherit the check.
 */
export const Route = createFileRoute('/dashboard/lobby')({
  beforeLoad: () => requireGameEnabled('lobby'),
  component: () => <Outlet />,
});
